import { render, staticRenderFns } from "./UnboxItemElement.vue?vue&type=template&id=398dde3c&scoped=true"
import script from "./UnboxItemElement.vue?vue&type=script&lang=js"
export * from "./UnboxItemElement.vue?vue&type=script&lang=js"
import style0 from "./UnboxItemElement.vue?vue&type=style&index=0&id=398dde3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398dde3c",
  null
  
)

export default component.exports